import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Seo from "@/components/feature/Seo";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Seo
        title="页面不存在 · 131吃瓜"
        description="你访问的页面不存在或链接已调整，可返回首页或前往事件档案继续浏览吃瓜实锤证据合集。"
        keywords="131吃瓜,页面不存在,证据合集"
        path="/404"
        type="website"
      />
      <SiteHeader />
      <main className="w-full bg-background-50 pt-28 md:pt-40 pb-20 min-h-[70vh]">
        <div className="max-w-[720px] mx-auto px-4 md:px-6 text-center">
          <span className="font-heading text-7xl md:text-9xl font-black text-background-200 select-none">404</span>
          <h1 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            这个页面还没被收录
          </h1>
          <p className="mt-3 text-sm leading-7 text-foreground-500">
            链接可能已调整，或者该内容尚未整理。回到首页或事件档案，可以看到目前收录的全部证据合集。
          </p>
          <p className="mt-3 text-xs text-foreground-500 break-all">{location.pathname}</p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              返回首页
            </Link>
            <Link
              to="/events"
              className="px-5 py-2.5 rounded-md border border-background-200 text-sm text-foreground-800 hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              浏览事件档案
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </>
  );
}